import React from 'react';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';

import CN from './SalonSpinner.module.scss';

const SalonSpinner = ({ variant, text }) => {
  const { isDarkMode } = useTheme();
  return (
    <div
      data-bem="SalonSpinner"
      className={cn({
        [CN.component]: true,
        [CN[`${variant}Variant`]]: variant,
        [CN.dark]: isDarkMode,
      })}
    >
      <svg className={CN.svg} viewBox="0 0 50 50">
        <circle className={CN.circle} cx="25" cy="25" r="20" fill="none" strokeWidth="5" />
      </svg>
      {text && <div className={CN.text}>{text}</div>}
    </div>
  );
};

export default SalonSpinner;
